import { SignaterRectangleLogo } from '../signater-rectangle-logo'
import { SignaterSquareLogo } from '../signater-square-logo'

interface SignaterLogoProps {
  className?: string
  size?: number
  variant?: 'rectangle' | 'square'
}

export function SignaterLogo({
  className,
  size = 32,
  variant = 'square',
}: SignaterLogoProps) {
  if (variant === 'rectangle') {
    return <SignaterRectangleLogo className={className} height={size} />
  }

  return <SignaterSquareLogo className={className} size={size} />
}
